const ADMIN_PRIVATE_WRAPPER = 'private';

export const FEATURE_STORE_KEY = 'fianza';

export const MODULE_PATHS_CONSTANTS = {
  BASE_ROUTE: 'fianza',
  // Cupos
  CUPOS: 'cupos',
  NEW_CUPO: 'cupo',
  MODIFY_NEW_CUPO: 'cupo/:id',
  // Pólizas
  POLIZAS: 'polizas',
  NEW_POLIZA: 'poliza',
  MODIFY_NEW_POLIZA: 'poliza/:id',
};

export const generateFullModuleRoute = (route: string): string => {
  return `${MODULE_PATHS_CONSTANTS.BASE_ROUTE}/${route}`;
};

export const fullAppPageRoute = (route: string): string => {
  return `${ADMIN_PRIVATE_WRAPPER}/${generateFullModuleRoute(route)}`;
};

export const MODULE_NAVIGATION_MENU = [
  {
    title: 'Fianza',
    collapsed: true,
    collapsable: true,
    activated: true,

    navigationItems: [
      {
        icon: 'pi pi-money-bill',
        route: generateFullModuleRoute(MODULE_PATHS_CONSTANTS.CUPOS),
        title: 'Cupos',
        activated: true,
      },
      {
        icon: 'pi pi-shield',
        route: generateFullModuleRoute(MODULE_PATHS_CONSTANTS.POLIZAS),
        title: 'Pólizas',
        activated: true,
      },
    ],
  },
];

export const MODULE_ROUTES_NOT_MENU = [
  {
    icon: 'fas fa-arrow-left',
    route: generateFullModuleRoute(MODULE_PATHS_CONSTANTS.MODIFY_NEW_CUPO),
    title: 'Solicitud de cupo',
    activateRoute: generateFullModuleRoute(MODULE_PATHS_CONSTANTS.CUPOS),
  },
  {
    icon: 'fas fa-arrow-left',
    route: generateFullModuleRoute(MODULE_PATHS_CONSTANTS.MODIFY_NEW_POLIZA),
    title: 'Solicitud de póliza',
    activateRoute: generateFullModuleRoute(MODULE_PATHS_CONSTANTS.POLIZAS),
  },
  {
    icon: 'fas fa-arrow-left',
    route: generateFullModuleRoute(MODULE_PATHS_CONSTANTS.NEW_CUPO),
    title: 'Solicitud de cupo',
    activateRoute: generateFullModuleRoute(MODULE_PATHS_CONSTANTS.CUPOS),
  },
  {
    icon: 'fas fa-arrow-left',
    route: generateFullModuleRoute(MODULE_PATHS_CONSTANTS.NEW_POLIZA),
    title: 'Solicitud de póliza',
    activateRoute: generateFullModuleRoute(MODULE_PATHS_CONSTANTS.POLIZAS),
  },
];

export const DATA_TABS = {
  SOLICITUD_CUPO: 'solicitudCupo',
  COMENTARIOS: 'comentarios',
  ANALISIS: 'analisis',
};

export const DOCUMENT_TYPES = {
  RUT: 'RUT',
  CI: 'CI',
};
